import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/Users/rich/github/remapgl/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Props } from "docz";
import Marker from "./marker";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "marker"
    }}>{`Marker`}</h1>
    <p>{`The `}<inlineCode parentName="p">{`<Marker/>`}</inlineCode>{` component is a child of `}<a parentName="p" {...{
        "href": "/remapgl/docs/map"
      }}>{`Map`}</a>{`, it causes a marker to appear at a specific location on a map. Markers can have a `}<a parentName="p" {...{
        "href": "/remapgl/docs/popup"
      }}>{`Popup`}</a>{` that provides more information.`}</p>
    <h2 {...{
      "id": "props"
    }}>{`Props`}</h2>
    <Props of={Marker} mdxType="Props" />
    <h2 {...{
      "id": "associated-types"
    }}>{`Associated Types`}</h2>
    <h3 {...{
      "id": "point"
    }}>{`Point`}</h3>
    <p>{`A Point geometry object, which has x and y properties representing screen coordinates in pixels.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Property`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Comments`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`x`}</strong></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`number`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`X coordinate in pixels.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`y`}</strong></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`number`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Y coordinate in pixels.`}</td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      